module.exports = __webpack_public_path__ + "img/verpak_jumpax_classic_staand.a271c97c.jpg";